import { gql } from '@apollo/client';

const GET_CURRENT_PRECO_OFFER = gql`
  query GetCurrentPrecoOffer($accountId: String!) {
    prechargeoffSettlementOffer(accountId: $accountId) {
      offerId
      createdAt
      updatedAt
      offerType
      data {
        offerId
        offerState
        referenceId
        stateExpiration
        type
        customerId
        accountId
        originalOutstandingBalance
        settlementBalance
        remainingBalance
        expirationDate
        payments {
          txId
          type
          amount
          date
        }
        paymentPlan {
          id
          status
          fundingAccount {
            id
            bankName
            numberLast4
          }
          transactions {
            amount
            date
            status
          }
        }
        terminationReason
        dscName
        offerTermsLabel
        paymentPlanId
      }
    }
  }
`;

const GET_PRECO_ELIGIBILITY = gql`
  query GetPrecoEligibility($accountId: String!) {
    precoEligibility(accountId: $accountId) {
      eligible
      requestId
      offer
      referenceId
      checks {
        name
        pass
      }
    }
  }
`;

const GET_AVAILABLE_PRECO_OFFERS = gql`
  query GetAvailablePrecoOffers($accountId: String!) {
    precoOffers(accountId: $accountId) {
      accountId
      outstandingBalance
      offers {
        offerId
        offerName
        settlementPercentage
        settlementBalance
        durationMonths
      }
    }
  }
`;

export {
  GET_CURRENT_PRECO_OFFER,
  GET_PRECO_ELIGIBILITY,
  GET_AVAILABLE_PRECO_OFFERS,
};
